
export const siteSchema = {
    name: '{ type:"input", rules:"required"}',
    description: '{ type:"textarea", rules:"required"}',
}